export default function ($provide) {
    $provide.decorator('maExportToCsvButtonDirective', ['$delegate', function($delegate) {
        //$delegate is array of all ng-click directive
        //in this case first one is angular buildin ng-click
        //so we remove it.
        $delegate.shift();
        return $delegate;
    }]);
};



/** WEBPACK FOOTER **
 ** ./js/config/overwrite_directives.js
 **/